import { render } from "./MicrosoftLogin.vue?vue&type=template&id=aadcc854"
import script from "./MicrosoftLogin.vue?vue&type=script&lang=js"
export * from "./MicrosoftLogin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__